import { render, staticRenderFns } from "./TyreFinder.vue?vue&type=template&id=29d36d61&"
import script from "./TyreFinder.vue?vue&type=script&lang=js&"
export * from "./TyreFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports